import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";

export default function OtherProposals({ searchObject, onChange, t }) {
  return (
    <div>
      <legend className="fontsize-legend">{t("Other Proposals")}</legend>
      <input
        name="otherProposals"
        onChange={onChange}
        value={searchObject.otherProposals || ""}
        className="form-control fontsize-legend"
      />
    </div>
  );
}
